import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import { getAccessibilityAttributes } from "replo-runtime/store/utils/accessibility";

import { ReploComponent } from "../ReploComponent";

const Container: React.FC<RenderComponentProps> = ({
  componentAttributes,
  component,
  context,
  overrideComponentTagType,
}) => {
  const isHiddenFromA11yTree = component.props._accessibilityHidden;
  const accessibilityAttributes = getAccessibilityAttributes({
    role: component.props._accessibilityRole,
    hidden: isHiddenFromA11yTree,
    checked: component.props._accessibilityChecked,
    labelledBy: component.props._accessibilityLabelledBy,
    label: isHiddenFromA11yTree
      ? undefined
      : component.props._accessibilityLabel,
  });

  const TagType =
    component.props._accessibilityHtmlTagType ??
    overrideComponentTagType ??
    "div";
  const isListTagType = ["ol", "ul"].includes(TagType);

  return (
    <TagType
      {...componentAttributes}
      {...accessibilityAttributes}
      key={componentAttributes.key}
    >
      {component?.children?.map((child) => {
        return (
          <ReploComponent
            key={child.id}
            component={child}
            context={context}
            overrideComponentTagType={isListTagType ? "li" : undefined}
          />
        );
      })}
    </TagType>
  );
};

export default Container;
